import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import WaveWinnersDropHeaderVoter from "./WaveWinnersDropHeaderVoter";
import { WAVE_VOTING_LABELS, WAVE_VOTE_STATS_LABELS } from "@/helpers/waves/waves.constants";
interface WaveWinnersDropHeaderVotersProps {
  readonly winner: ApiWaveDecisionWinner;
}
export default function WaveWinnersDropHeaderVoters(t0) {
  const $ = _c(21);
  const {
    winner
  } = t0;
  const userVote = winner.drop.context_profile_context?.rating ?? 0;
  const hasUserVoted = userVote !== 0;
  const isNegativeVote = userVote < 0;
  const userVoteClass = isNegativeVote ? "tw-text-rose-400" : "tw-text-iron-50";
  const hasTopRaters = winner.drop.top_raters.length > 0;
  let t1;
  if ($[0] !== hasTopRaters || $[1] !== winner) {
    t1 = hasTopRaters && <div className="tw-flex tw-items-center -tw-space-x-2">{winner.drop.top_raters.map((voter, index) => <WaveWinnersDropHeaderVoter voter={voter} winner={winner} index={index} key={voter.profile.handle} />)}</div>;
    $[0] = hasTopRaters;
    $[1] = winner;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== winner.drop.raters_count) {
    t2 = formatNumberWithCommas(winner.drop.raters_count);
    $[3] = winner.drop.raters_count;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = winner.drop.raters_count === 1 ? "voter" : "voters";
  let t4;
  if ($[5] !== t3) {
    t4 = <span className="tw-font-normal tw-text-iron-400">{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <span className="tw-font-medium tw-text-iron-50">{t2}{" "}{t4}</span>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap tw-text-sm tw-leading-5">{t1}{t5}</div>;
    $[10] = t1;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== hasUserVoted || $[14] !== userVote || $[15] !== userVoteClass || $[16] !== winner.drop.wave) {
    t7 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-leading-5"><span className="tw-whitespace-nowrap"><span className="tw-font-normal tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:{" "}</span><span className={`tw-font-medium ${userVoteClass}`}>{formatNumberWithCommas(userVote)}{" "}{WAVE_VOTING_LABELS[winner.drop.wave.voting_credit_type]}</span></span></div>;
    $[13] = hasUserVoted;
    $[14] = userVote;
    $[15] = userVoteClass;
    $[16] = winner.drop.wave;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-gap-x-4 tw-gap-y-2">{t6}{t7}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}